import * as Contractor from '../schemas/inductions/DDH/Contractor.json'

export default {
    type: 'DDH Induction',
    schemas: {
        'DDH Contractor': Contractor,
    }
}